import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BrandColors } from '../../constants';

export const NoFooterStyles = makeStyles()((theme: Theme) => ({
  screenContainer: {
    '& #root > footer, #root > .icp-recordal-footer': {
      display: 'none',
    },
    '& #root > .main-content': {
      minHeight: 'calc(100vh - 40px) !important',
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 50px) !important',
      },
    },
  },
}));

export const ManagerStartStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'inherit',
    background: theme.palette.background.default,
  },
  content: {
    paddingTop: '4rem',
    maxWidth: '42.82rem',
    paddingLeft: '1.87rem',
    paddingRight: '1.87rem',
    [theme.breakpoints.up('md')]: {
      paddingTop: '6.5rem',
    },
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: '2rem',
    color: theme.palette.default?.main || BrandColors.black,
    [theme.breakpoints.up('md')]: {
      fontSize: '2rem',

      lineHeight: '3.37rem',
    },
  },
  margintop2: {
    marginTop: '2.5rem',
  },
  padding1: {
    paddingTop: '1rem',
  },
  instructions: {
    fontSize: '1.12rem',
    fontWeight: 400,
    lineHeight: '1.87rem',
    color: theme.palette.default?.main || BrandColors.black,
  },
  buttonBlock: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '3.12rem',
  },
  buttons: {
    borderRadius: '2rem',
    width: '6.25rem',
    height: '2.5rem',
    wordSpacing: '0.425rem',
    letterSpacing: '0.15rem',
    border: '2px solid',
    marginLeft: 0,
    fontSize: '0.813rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    background: theme.palette.background.paper,
    borderColor: theme.palette.primary.main,
    '&:hover': {
      border: '2px solid',
      background: theme.palette.primary.main,
      borderColor: theme.palette.background.paper,
      color: theme.palette.background.paper,
    },
    [theme.breakpoints.up('md')]: {
      padding: '0.438rem 1rem',
    },
  },
}));
